<template>
  <div>
    <InvestmentManagerIndexMobile
      v-if="isMobile"
      :other-links="$options.otherLinks"
      :page-description="$options.pageDescription"
      :base-url="$options.baseUrl"
      :content-data="$options.contentData"
    />
    <InvestmentManagerIndexDesktop
      v-else
      :other-links="$options.otherLinks"
      :page-description="$options.pageDescription"
      :base-url="$options.baseUrl"
      :content-data="$options.contentData"
      :breadcrumb-links="$options.breadcrumbLinks"
    />
  </div>
</template>

<script>
import {
  generateOtherLinks,
  getInvestmentManagerObject,
  generateBreadcrumbLinks,
  seoMapperConstant as CONSTANT,
} from 'shared/helpers/seoMap';
import isMobile from 'shared/mixins/isMobile';
import InvestmentManagerIndexMobile from '../../components/mobile/investment_manager/InvestmentManagerIndex';
import InvestmentManagerIndexDesktop from '../../components/desktop/investment_manager/InvestmentManagerIndex';

const investmentManagerObject = getInvestmentManagerObject();

export default {
  name: 'InvestmentManagerIndexPage',
  metaInfo() {
    return {
      title: investmentManagerObject.meta_title,
      meta: [
        { name: 'description', content: investmentManagerObject.meta_desc },
        { name: 'keyword', content: investmentManagerObject.meta_keyword },
      ],
    };
  },
  components: {
    InvestmentManagerIndexMobile,
    InvestmentManagerIndexDesktop,
  },
  mixins: [isMobile],
  otherLinks: generateOtherLinks(CONSTANT.INVESTMENT_MANAGER_KEY),
  pageDescription: investmentManagerObject.page_desc,
  baseUrl: investmentManagerObject.link_url,
  contentData: investmentManagerObject.data,
  breadcrumbLinks: generateBreadcrumbLinks(CONSTANT.INVESTMENT_MANAGER_KEY),
};
</script>
